import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/sections.css';
import '../../styles/appshowcase.css';

import notify1 from '../../assets/notify_1.png';
import notify2 from '../../assets/notify_2.png';
import notify3 from '../../assets/notify_3.png';
import notify4 from '../../assets/notify_4.png';
import notify5 from '../../assets/notify_5.png';
import notify6 from '../../assets/notify_6.png';
import notify7 from '../../assets/notify_7.png';
import notify8 from '../../assets/notify_8.png';
import notify9 from '../../assets/notify_9.png';
import notify10 from '../../assets/notify_10.png';
import notify11 from '../../assets/notify_11.png';
import notify12 from '../../assets/notify_12.png';
import notify13 from '../../assets/notify_13.png';
import notify14 from '../../assets/notify_14.png';
import notify15 from '../../assets/notify_15.png';
import notify16 from '../../assets/notify_16.png';

const AppShowcase = () => {
  return (
          <section className="appshowcase-section">
        <div className="section-header">
          <h2>APP SHOWCASE</h2>
          <div className="underline"></div>
        </div>
        <div className="appshowcase-content">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={5000}
          showStatus={false}
          dynamicHeight={false}
        >
          {[notify1, notify2, notify3, notify4, notify5, notify6, notify7, notify8, notify9, notify10, notify11, notify12, notify13, notify14, notify15, notify16].map((img, idx) => (
            <div key={idx}>
              <img src={img} alt={`Notify Slide ${idx + 1}`} />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default AppShowcase;
